@if (device() !== DeviceType.DESKTOP && untienotsId) {
  <div
    class="go-back-challenges-button"
    [class.has-top-navbar]="navbar.hasLayoutPaddingTop"
  >
    <a routerLink="../current" class="back-button" queryParamsHandling="merge">
      <p
        class="text-container"
        [style.backgroundColor]="config.header.goBackButton.backgroundColor"
        [style.color]="config.header.goBackButton.color"
        [style.fontFamily]="config.header.goBackButton.fontFamily"
        [style.borderRadius]="config.header.goBackButton.borderRadius"
      >
        {{ config.header.goBackButton.text }}
      </p>
    </a>
  </div>
}

<div class="component-container">
  <div
    class="header"
    [style]="{
      marginBottom: !untienotsId ? '5rem' : '0',
      borderBottom: config.header.borderBottom,
      borderTop: config.header.borderTop,
    }"
  >
    <!-- Chondrus Header -->
    @if (Retailers.CHONDRUS === retailerName && !untienotsId) {
      <div
        class="chondrus-header-wrapper"
        [style.background]="config.header.background"
      >
        @if (config.header.logo) {
          <a
            routerLink="../login"
            class="link retailer-logo"
            queryParamsHandling="merge"
            [attr.aria-label]="config.header.logo.ariaLabel"
            [title]="config.header.logo.ariaLabel"
          >
            <img
              class="help-btn-icon"
              [ngSrc]="config.header.logo.imageUrl"
              [alt]="config.header.logo.alternativeText"
              [width]="config.header.logo.width"
              [height]="config.header.logo.height"
            />
          </a>
        }
        @if (config.header.backButton) {
          <a
            routerLink="../login"
            class="link back-button"
            queryParamsHandling="merge"
            [attr.aria-label]="config.header.backButton.ariaLabel"
            [title]="config.header.backButton.ariaLabel"
          >
            <img
              [alt]="config.header.backButton.alternativeText"
              class="help-btn-icon"
              [src]="config.header.backButton.imageUrl"
            />
          </a>
        }
      </div>
    }

    <!-- back Button -->
    @if (config.header.backButton && Retailers.CHONDRUS !== retailerName) {
      <div class="back-button">
        <button
          type="button"
          (click)="goBack()"
          class="back-button-btn"
          [attr.aria-label]="config.header.backButton.ariaLabel"
        >
          <img
            aria-hidden="true"
            [src]="config.header.backButton.imageUrl"
            [alt]="config.header.backButton.alternativeText"
          />
        </button>
      </div>
    }

    @if (config.header.backButtonTemplate && !untienotsId) {
      <button
        type="button"
        (click)="goBack()"
        class="back-button-custom"
        [attr.aria-label]="config.header.backButton?.ariaLabel || 'Go back'"
      >
        <b2c-template [template]="config.header.backButtonTemplate" />
      </button>
    }

    <!-- Banner -->
    @if (config.header.bannerUrl) {
      <img
        [alt]="config.header.bannerAlternativeText"
        class="banner-img"
        [src]="config.header.bannerUrl[device()]"
      />
    }

    @if (config.header.title) {
      <h1 class="header-title" [style]="config.header.title.styles">
        {{ config.header.title.text }}
      </h1>
    }

    <!-- How To Play Component -->
    @if (showTutorial()) {
      <b2c-how-to-play
        [config]="config.header.howToPlay"
        [background]="config.header.background"
      />
    }
  </div>

  <!-- Template -->
  @if (config.template) {
    <b2c-template [template]="config.template[device()]" />
  }

  <!-- Faq -->
  <b2c-faq data-cy="faq" />

  <!-- Template Before Contact Form -->
  @if (
    (dataService.activeTabs.faq() === CampaignTypes.LOYALTYCHALLENGE &&
      config.templateBeforeContactForm) ||
    (dataService.activeTabs.faq() === CampaignTypes.LOYALTYCHALLENGE_BIS &&
      config.loyaltychallengeBis?.templateBeforeContactForm)
  ) {
    <b2c-template
      [template]="
        (dataService.activeTabs.faq() === CampaignTypes.LOYALTYCHALLENGE
          ? config.templateBeforeContactForm || []
          : config.loyaltychallengeBis?.templateBeforeContactForm || []
        )
          | join
          | replaceVars
            : (dataService.currentCampaign().startDate
                | date: 'dd MMMM yyyy') || ''
          | replaceVars
            : (dataService.currentCampaign().endDate | date: 'dd MMMM yyyy') ||
                ''
          | replaceVars
            : (dataService.currentCampaign().startDate
                | date: 'dd MMMM yyyy') || ''
          | replaceVars
            : (dataService.currentCampaign().endDate | date: 'dd MMMM yyyy') ||
                ''
      "
      id="terms"
    />
  }

  <!-- Extra Links -->
  @if (
    (dataService.activeTabs.faq() === CampaignTypes.LOYALTYCHALLENGE &&
      config.extraLinks) ||
    (dataService.activeTabs.faq() === CampaignTypes.LOYALTYCHALLENGE_BIS &&
      config.loyaltychallengeBis?.extraLinks)
  ) {
    <div class="extra-links">
      @for (
        item of dataService.activeTabs.faq() === CampaignTypes.LOYALTYCHALLENGE
          ? config.extraLinks || []
          : config.loyaltychallengeBis?.extraLinks || [];
        track $index
      ) {
        @if (!(item.hideInIframe && iframeTools.isInIframe)) {
          <div class="extra-link-container">
            <p class="label" [style.fontFamily]="item.title.fontFamily">
              {{ item.title.text }}
            </p>
            <a
              class="link"
              target="_blank"
              rel="noopener noreferrer"
              [href]="item.link.href"
              [style]="{
                color: item.link.color,
                fontFamily: item.link.fontFamily,
                backgroundColor: item.link.backgroundColor,
              }"
            >
              {{ item.link.label }}
            </a>
          </div>
        }
      }
    </div>
  }

  <!-- Contact Link | Contact Form -->
  @if (
    (!iframeTools.isInIframe && config.contactUs && untienotsId) ||
    (!iframeTools.isInIframe &&
      config.contactUs &&
      !untienotsId &&
      config.displayContactUsUnlogged)
  ) {
    <div
      class="form-container"
      id="contact-form"
      [class.has-contact-form]="config.contactUs.type === ContactUsType.FORM"
    >
      <!-- Contact Link Component -->
      @if (config.contactUs.type === ContactUsType.LINK) {
        <b2c-contact-link [config]="config.contactUs.config" />
      }

      <!-- Contact Template Component -->
      @if (config.contactUs.type === ContactUsType.TEMPLATE) {
        <b2c-template [template]="config.contactUs.config" />
      }

      <!-- Contact Form Component -->
      @if (config.contactUs.type === ContactUsType.FORM) {
        <b2c-contact-form [config]="config.contactUs.config" />
      }
    </div>
  }

  <!-- Template After Contact Form -->
  @if (
    (dataService.activeTabs.faq() === CampaignTypes.LOYALTYCHALLENGE &&
      config.templateAfterContactForm) ||
    (dataService.activeTabs.faq() === CampaignTypes.LOYALTYCHALLENGE_BIS &&
      config.loyaltychallengeBis?.templateAfterContactForm)
  ) {
    <b2c-template
      id="general-conditions"
      [template]="
        dataService.activeTabs.faq() === CampaignTypes.LOYALTYCHALLENGE
          ? config.templateAfterContactForm || []
          : config.loyaltychallengeBis?.templateAfterContactForm || []
      "
    />
  }

  <!-- Template After Form -->
  @if (
    (dataService.activeTabs.faq() === CampaignTypes.LOYALTYCHALLENGE &&
      config.templateAfterForm) ||
    (dataService.activeTabs.faq() === CampaignTypes.LOYALTYCHALLENGE_BIS &&
      config.loyaltychallengeBis?.templateAfterForm)
  ) {
    <b2c-template
      id="legal-notice"
      [template]="
        dataService.activeTabs.faq() === CampaignTypes.LOYALTYCHALLENGE
          ? config.templateAfterForm || []
          : config.loyaltychallengeBis?.templateAfterForm || []
      "
    />
  }

  <!-- Template Before Changes -->
  @if (
    (dataService.activeTabs.faq() === CampaignTypes.LOYALTYCHALLENGE &&
      config.templateBeforeChanges) ||
    (dataService.activeTabs.faq() === CampaignTypes.LOYALTYCHALLENGE_BIS &&
      config.loyaltychallengeBis?.templateBeforeChanges)
  ) {
    <b2c-template
      [template]="
        dataService.activeTabs.faq() === CampaignTypes.LOYALTYCHALLENGE
          ? config.templateBeforeChanges || []
          : config.loyaltychallengeBis?.templateBeforeChanges || []
      "
    />
  }

  @if (!untienotsId && config.displayFooterUnlogged) {
    <b2c-footer />
  }
</div>
